import { UpdateCrecaTradesApi } from "@/features/accounts/creca/services/update-trades-api";
import { PostCrecaTradesRequestModel } from "@/features/accounts/creca/services/update-trades-model";

/// クレカ明細更新処理
export class UpdateCrecaTradesService {
  private updateCrecaTradesApi = new UpdateCrecaTradesApi();

  /**
   * クレカ明細更新API実行
   */
  public async updateCrecaTrades(param: PostCrecaTradesRequestModel) {
    return await this.updateCrecaTradesApi.updateCrecaTrades(param);
  }
}
